import { ReactNode } from 'react';
import { TimelineItem } from '@/common/components/timeline/subcomponents/timeline-item/TimelineItem.tsx';
import { TimelineIcon } from '@/common/components/timeline/subcomponents/timeline-icon/TimelineIcon.tsx';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { blueGrey } from '@mui/material/colors';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

export interface TimelineLoadMoreProps {
  buttonLabel?: ReactNode;
  onClick?: () => void;
}

export const TimelineLoadMore = ({ buttonLabel, onClick }: TimelineLoadMoreProps) => {
  return (
    <TimelineItem
      isLast
      icon={
        <TimelineIcon color={blueGrey}>
          <ExpandMoreIcon />
        </TimelineIcon>
      }
      rightContent={
        <Box pt={1.5}>
          <Button onClick={onClick} variant="outlined" size="small">
            {buttonLabel}
          </Button>
        </Box>
      }
    />
  );
};
